import { render } from "./PercentageScale.vue?vue&type=template&id=797ccb5b"
import script from "./PercentageScale.vue?vue&type=script&lang=js"
export * from "./PercentageScale.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__